import React from 'react'
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from './PageAnimations';

const Resume = (props) => {

    return (
        <motion.div initial="out" animate="in" exit="out" variants={pageVariants} transition={pageTransition} >
            <h2>this is resume component</h2>
        </motion.div>
    )
}

export default Resume;
